var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doorderhome"},[_c('SidebarDoorder'),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('NavbarDoorder'),_vm._v(" "),_c('div',{staticClass:"content",staticStyle:{"margin-top":"50px"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ff8f4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/doorder/Home.vue
// module id = null
// module chunks = 